export default __webpack_public_path__ + "static/media/NGR.10b661cd.svg";